import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import Companies from "@/pages/Companies";
import CompanyProfile from "@/pages/CompanyProfile";
import SubmitReview from "@/pages/SubmitReview";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Moderation from "@/pages/Moderation";
import Rankings from "@/pages/Rankings";
import Trust from "@/pages/Trust";
import Compare from "@/pages/Compare";
import Portfolio from "@/pages/Portfolio";
import Verify from "@/pages/Verify";
import Recruiters from "@/pages/Recruiters";
import RecruiterProfile from "@/pages/RecruiterProfile";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import PostJob from "@/pages/PostJob";
import LicenseeDetail from "@/pages/LicenseeDetail";
import Coverage from "@/pages/Coverage";
import ContentPage from "@/pages/ContentPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="grain min-h-screen">
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/company/:id" element={<CompanyProfile />} />
            <Route path="/company/:id/verify" element={<Verify />} />
            <Route path="/company/:id/review" element={<SubmitReview />} />
            <Route path="/recruiters" element={<Recruiters />} />
            <Route path="/recruiter/:id" element={<RecruiterProfile />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/new" element={<PostJob />} />
            <Route path="/job/:id" element={<JobDetail />} />
            <Route path="/careers/:id" element={<LicenseeDetail />} />
            <Route path="/coverage" element={<Coverage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/moderation" element={<Moderation />} />
            <Route path="/rankings" element={<Rankings />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/about" element={<ContentPage slug="about" />} />
            <Route path="/trust" element={<Trust />} />
            <Route path="/p/:slug" element={<ContentPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
          <Footer />
        </div>
        <Toaster position="top-right" richColors theme="light" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
